import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import routerBrowser from './Routes';
import { ContextProvider } from './Context';
import { startVersionWatcher } from './Services/VersionCheck';

// Clickjacking defense-in-depth: refuse to run inside a cross-origin frame.
// Primary protection is the HTTP headers set in public/.htaccess; this covers
// legacy browsers and any host where mod_headers is unavailable.
// Same-origin framing is allowed, matching frame-ancestors 'self' / SAMEORIGIN.
if (window.top !== window.self) {
  let sameOriginTop = false;
  try {
    sameOriginTop = window.top.location.origin === window.self.location.origin;
  } catch {
    // Reading a cross-origin top's location throws: treat as untrusted.
    sameOriginTop = false;
  }

  if (!sameOriginTop) {
    try {
      window.top.location = window.self.location.href;
    } catch {
      // Cross-origin top we can't redirect: neutralize the page instead.
      document.documentElement.innerHTML =
        'This application cannot be displayed in a frame.';
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <Suspense fallback={fallback()}>  
  <ContextProvider value="test">
    <RouterProvider router={routerBrowser} />
  </ContextProvider>
  // </Suspense>
);

// Watch for a newly deployed build and prompt the user to reload into it.
// No-op outside production builds.
startVersionWatcher();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();